import React from "react";

export default function BaseCard(props) {
    return (
        <div style={{ backgroundColor: '#FFF' }} >
            {props.children}
        </div>
    )
}